// extracted by mini-css-extract-plugin
export default {"propsList":"styles_propsList__uOKPA","noFavorites":"styles_noFavorites__na3Nd","noFavoritesText":"styles_noFavoritesText__hPkbQ"};